import React from "react";
import { useMessageSource } from "react-message-source";
import RadioButtonContainer from "../../../../ui/layout/page/forms-container/form-item-container/radio-button-container/input-container";
import AmountField from "../../../../ui/widgets/amount";
import GTM from "../../../../util/tracking/gtm";
import {
  EventCategory,
  SameOrOtherEvent,
} from "../../../../util/tracking/types";
import RadioButtonField from "../../../shared/components/formik/radiobutton";
import { CardLimitType } from "./types";
import useCardLimitOptionsValues from "./useCardLimitOptionsValues";
import InputContainer from "../../../../ui/layout/page/forms-container/form-item-container/input-container";

export default function CardLimit({
  dataPath = "",
  spendingLimit,
  spendingLimitOther,
}: {
  dataPath?: string;
  spendingLimit?: CardLimitType;
  spendingLimitOther?: string;
}): React.JSX.Element {
  const { getMessage } = useMessageSource();

  return (
    <React.Fragment>
      <RadioButtonContainer>
        <RadioButtonField
          id={`${dataPath}spendingLimit`}
          title={getMessage("Cardholder.limit-title")}
          name={`${dataPath}spendingLimit`}
          descriptionText={
            spendingLimit === CardLimitType.LIMIT_OTHER
              ? getMessage("Cardholder.limit-helperUnderInput")
              : undefined
          }
          values={useCardLimitOptionsValues()}
          onChangeCallback={(_, newValue) => {
            GTM.trackEvent(
              EventCategory.CardLimit,
              newValue === CardLimitType.LIMIT_OTHER
                ? SameOrOtherEvent.Other
                : `${newValue}`,
            );
          }}
        />
      </RadioButtonContainer>
      {spendingLimit === CardLimitType.LIMIT_OTHER && (
        <InputContainer>
          <AmountField
            name={`${dataPath}spendingLimitOther`}
            value={spendingLimitOther}
            label={getMessage("CardLimit.OTHER")}
          />
        </InputContainer>
      )}
    </React.Fragment>
  );
}
